import { css, html } from 'lit';
import { property } from 'lit/decorators.js';
import { PublicAppElement } from './public-app-element';
import { PublicAppStyles } from './public-app-styles';

export class PublicAppHeader extends PublicAppElement {
    static styles = PublicAppStyles.stylesHeader.concat(
        PublicAppStyles.stylesTables
    );
    mouseOverHandler(e) {
        let element: any = e.target;
        let buttonImage = element && element.parentNode.querySelector("#LogInButton");
        if (buttonImage) {
            buttonImage.src = '/images/external/btn_login_on.gif';
        }
    }

    mouseOutHandler(e) {
        let element: any = e.target;
        let buttonImage = element && element.parentNode.querySelector("#LogInButton");
        if (buttonImage) {
            buttonImage.src = '/images/external/btn_login.gif';
        }
    }

    getHeaderClass(): String {
        return "masthead-" + this.runMode;
    }

    onMenuIconClick(e) {
        e && e.stopPropagation();
        this.publicApp().toggleHamburgerMenu();
    }

    onDesktopMenuIconClick(e){
        e && e.stopPropagation();
        this.publicApp().clearNavMenuSearch()
    }

    render() {
        return html`
        <link rel="stylesheet" href="/css/global.css?v=${this.appVersion}">
		<div class="container-fluid move-container transaction-main-div">
            <div id="header1" class="header-masthead" >
                <div class="${this.getHeaderClass()} masthead masthead-responsive">
                    <i id="hamburger-icon" class="bi bi-list navbar-brand hamburger-icon d-lg-none" href="javascript:void(0);" @click=${this.onMenuIconClick}></i>
                    <i id="hamburger-icon" class="bi bi-list navbar-brand hamburger-icon d-none d-lg-block" href="javascript:void(0);" @click=${this.onDesktopMenuIconClick}></i>
                    <a href="/index.html"><h1 class="logo">SoCalGas A Sempra Energy Utility</h1></a>
                    <span class="title ">SoCalGas ENVOY<sup>&reg;</sup></span>
                </div>
                <div id="responsiveDiv" class="mastheadSearch" style="display:none">
                    <div class="showOnSmallDevice"  >
                        <div class="searchMobile col-12 col-lg-3 clear-both"> 
                            <div class="input-search-public-site text-center">
                                <form action="https://interface.us.q-go.net/socalgas/"  onSubmit="showSearchResults(this, 'searchResults')" method="GET" class="gSearchForm">
                                    <!-- <div class="search-icon-public-text-wrap">
                                        <input name="q" type="text" maxlength="255" id="gsearchbox" class="gSearch_box search-icon-public-text" value="" placeholder="Search">
                                        <button type="submit" onclick="showSearchResults(this, 'searchResults')" class="search-icon-wrap">
                                        ** Note: Replace font-awesome icon with bootstrap icon since font-awesome libary has been removed
                                        <i class="fa fa-search"></i></button>
                                    </div> -->
                                    <input type="hidden" name="site" value="Envoy"/>
                                    <input type="hidden" name="client" value="envoy_frontend"/>
                                    <input type="hidden" name="sort" value="date:D:L:d1"/>
                                    <input type="hidden" name="output" value="xml_no_dtd"/>
                                    <input type="hidden" name="proxystylesheet" value="envoy_frontend"/>
                                </form>	
                            </div>
                        </div>
                    </div>
                </div>
                <div id="loginButtonOverlayDesktop" class="loginButtonOverlayDesktop">
                    <form action="https://interface.us.q-go.net/socalgas/" onsubmit="showSearchResults(this, 'searchResults')" method="GET" class="gSearchForm">
                        <table class="krypton-table-style">
                            <tbody>
                                <tr>
                                    <td>
                                        <input type="hidden" name="site" value="Envoy">
                                        <input type="hidden" name="client" value="envoy_frontend">
                                        <input type="hidden" name="sort" value="date:D:L:d1">
                                        <input type="hidden" name="output" value="xml_no_dtd">
                                        <input type="hidden" name="proxystylesheet" value="envoy_frontend">
                                    </td>
                                </tr>
                                <tr style="display: flex; column-gap: 16px;" class="justify-content-end">
                                    <!-- mWeb Search bar -->
                                    <!-- <td align="right" class="showOnSmallDevice">
                                    <button type="button" class="g-primary-outline-button" id="gsearchbutton" onclick="javascript:enableResponsiveSearch()">
                                    ** Note: Replace font-awesome icon with bootstrap icon since font-awesome libary has been removed
                                    <i class="fa fa-search"></i></button>
                                    </td> -->
                                    <!-- Hidding Search bar -->
                                    <!-- <td class="g-search-bar-wrap showOnLargeDevice">
                                        <input name="q" type="text" maxlength="255" class="gSearch_box" id="gsearchbox" placeholder="Search">
                                        <button type="submit" class="search-icon-wrap">
                                        ** Note: Replace font-awesome icon with bootstrap icon since font-awesome libary has been removed
                                        <i class="fa fa-search"></i></button>
                                    </td> -->
                                    <td>
                                        <!-- Desktop Login button -->
                                        <button type="button" class="g-primary-button g-primary-button-${this.runMode} btn btn-primary" onclick="popNewTab();">Login</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </form>
                </div>
            </div>
        </div>
        `;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        'public-app-header': PublicAppHeader;
    }
}

